module.exports = __webpack_public_path__ + "static/media/world_panel.a14e06fe.jpg";